import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/Button';

export default function ItemNotFound() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center gap-4 py-12">
      <h2 className="text-xl font-semibold text-foreground">Could not find item</h2>
      <Button onClick={() => navigate('/in/folder/root')}>Return home</Button>
    </div>
  );
}
